import {
  Flex,
  Heading,
  Text,
  Box,
  Image,
} from "@chakra-ui/react";
import Section from "./Section";
import Header from "./Header";
import Footer from "./Footer";
import { MAIN, SECONDARY } from "./colours";

export default function About() {
  return (
    <>
      <Header />
      <Section title="ABOUT">
        <Flex flexDir={"column"} color={MAIN}>
          <Text fontSize={"lg"} mb="6">
            Hi, we're Harri and Meg, and we run Happy Fig – a catering company based in North Wales.
          </Text>
          <Text fontSize={"lg"} mb="6">
            We cook seasonal food using local produce, work closely with suppliers we trust, and love creating food that brings people together, whether that's around a long wedding table or a kitchen island.
          </Text>
          <Text fontSize={"lg"} mb="6">
            Happy Fig began with a simple idea: to cook honest, seasonal food for gatherings, using the best produce North Wales has to offer.
          </Text>
          <Text fontSize={"lg"} mb="6">
            What started in home kitchens grew through word of mouth, from intimate dinners to long-table weddings, retreats, supper clubs and large celebrations across the region.
          </Text>
          <Text fontSize={"lg"}>
            Over time, we've built a small, skilled team and strong relationships with local farmers, fishers and producers. We now cook everywhere from gardens and holiday homes to estates, wedding venues and coastal locations, and that flexibility has shaped how we work today.
          </Text>
        </Flex>
      </Section>

      <Flex>
        <Box w={{ base: "100%", lg: "33.33%" }}>
          <Image src="/cabbages.jpeg" alt="Fresh local cabbages" w="100%" h="100%" objectFit="cover" />
        </Box>
        <Box display={{ base: "none", lg: "block" }} w="33.33%">
          <Image src="/produce.jpeg" alt="Fresh local produce" w="100%" h="100%" objectFit="cover" />
        </Box>
        <Box display={{ base: "none", lg: "block" }} w="33.33%">
          <Image src="/carrots.jpeg" alt="Fresh local carrots" w="100%" h="100%" objectFit="cover" />
        </Box>
      </Flex>

      <Section title="WHO WE WORK WITH" secondary>
        <Flex flexDir={"column"} color={SECONDARY}>
          <Text fontSize={"lg"} mb="8">
            We're proud to work with brilliant venues, partners and producers across North Wales.
          </Text>
          <Heading size="lg" mb="4">Venues & partners</Heading>
          <Text fontSize={"lg"} mb="8">
            Oyster Holidays, Boltholes and Hideaways, Tŷ Afon, Llyn Gwynant Barns, retreat hosts and private venues across the region.
          </Text>
          <Heading size="lg" mb="4">Suppliers & producers</Heading>
          <Text fontSize={"lg"}>
            Pandy Farm, Menai Seafood, Wavells Butchers, Tyddyn Teg, Moelyci, Growing for Change and other local farms, growers and makers.
          </Text>
        </Flex>
      </Section>
      <Footer />
    </>
  );
}
